








































































































































































import { Component, Ref, Vue, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import EventBus from '@/plugins/EventBus'
import { onlyNumber, timeout } from '@/utils/common'
import { Procedimento } from '@/types/_'

@Component

export default class ComponentModalBackofficeEditarProcedimentoPrincipal extends Vue {
  @Prop({ required: false, default: false }) disabled: boolean

  $refs!: { quantidadeForm: any }

  inputSearch: string = ''
  loadEditProcedimentoPrincipal: boolean = false

  get loadingEditProcedimentoPrincipal() { return this.loadEditProcedimentoPrincipal }
  set loadingEditProcedimentoPrincipal(value: boolean) { this.loadEditProcedimentoPrincipal = value }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get lateralidadeObrigatoria() {
    const { template } = this.getBackofficeGlobalStore
    return !!template.formulario && !!template.formulario.lateralidade && !!template.formulario.lateralidade.exigeLateralidadeEmTodosOsProcedimentos
  }

  get showModalEditarProcedimentoPrincipal() {
    return this.getBackofficeGlobalStore.modal.editarProcedimentoPrincipal
  }

  set showModalEditarProcedimentoPrincipal(value: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'editarProcedimentoPrincipal', value })
  }

  get procedimentoPrincipal() {
    return this.getBackofficeGlobalStore.procedimentoPrincipal
  }

  get getProcedimentosApi() {
    return this.getBackofficeGlobalStore.procedimentosApi
  }

  get getInputSearch() {
    return this.inputSearch
  }

  set getInputSearch(value) {
    this.inputSearch = value
  }

  addSelected(item) {
    this.procedimento = { quantidade: 1, lateralidade: '', procedimentoPrincipal: true, ...item }
    this.showModalQuantidade = true
  }

  async editSelected(item) {
    this.loadingEditProcedimentoPrincipal = true
    await timeout(500)
    this.procedimento = { ...item, procedimentoPrincipal: true, lateralidade: item.lateralidade.key || '' }
    this.showModalQuantidade = true
    this.loadingEditProcedimentoPrincipal = false
  }

  debounce = _.debounce(input => this.getBackofficeGlobalStore.getProcedimentosBackofficeSearch(input), 600)

  search(input) {
    if (this.inputSearch.length === 0 || this.inputSearch.length > 2) {
      this.debounce(this.inputSearch)
    }
  }

  @Watch('showModalEditarProcedimentoPrincipal')
  onChangeshowModalEditarProcedimentoPrincipal(value) {
    setTimeout(() => {
      const input = document.querySelector('.procedimentos-principal-backoffice-input input') as HTMLInputElement
      this.getInputSearch = ''
      if (value) {
        input.focus()
      } else {
        input.blur()
        this.getBackofficeGlobalStore.clearProcedimentosApi()
      }
    }, 100)
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  temFlagDeLateralidadeObrigatoria(value) {
    if (this.lateralidadeObrigatoria && [null, undefined, ''].includes(value)) return false
    return true
  }

  quantidadeRules: any = {
    valid: true,
    quantidade: [v => !!v || 'Campo obrigatório.'],
    lateralidade: [v => this.temFlagDeLateralidadeObrigatoria(v) || 'Campo obrigatório.'],
  }

  procedimento: any = null
  modalQuantidade: boolean = false
  loadSaveProcedimentoPrincipal: boolean = false

  get showModalQuantidade() { return this.modalQuantidade }
  set showModalQuantidade(value: boolean) { this.modalQuantidade = value }

  @Watch('showModalQuantidade')
  onChangeShowModalQuantidade(value) {
    if (!value) {
      this.procedimento = null
    }
  }

  get loadingSaveProcedimentoPrincipal() { return this.loadSaveProcedimentoPrincipal }
  set loadingSaveProcedimentoPrincipal(value: boolean) { this.loadSaveProcedimentoPrincipal = value }

  async verificarCoberturaVigente(procedimento: Procedimento) {
    const { hospital } = this.getBackofficeGlobalStore.solicitacaoAlterada
    // @ts-ignore
    if (!hospital.hospitalFazConsultaCoberturaVigente || hospital.tipoDeCoberturaVigente !== 'Procedimento') return
    const request = await this.getBackofficeGlobalStore.consultaCoberturaVigente(procedimento.id)
    if (request.success) this.getBackofficeGlobalStore.setProcedimentoPrincipalCoberturaVigente({ ...procedimento, coberturaVigente: request.data.temCoberturaVigente })
  }

  async save() {
    if (!this.$refs.quantidadeForm.validate()) return
    this.loadingSaveProcedimentoPrincipal = true
    const procedimentoPrincipal: any = { ...this.procedimento }

    Object.entries(procedimentoPrincipal).forEach(([key, value]) => {
      // @ts-ignore
      if (['', null, 0, undefined].includes(value)) {
        delete procedimentoPrincipal[key]
      }
    })

    const lateralidade = !procedimentoPrincipal.lateralidade ? 'NaoAplica' : procedimentoPrincipal.lateralidade

    let procedimentoNew = {
      codigo: procedimentoPrincipal.codigo,
      descricao: procedimentoPrincipal.descricao,
      id: procedimentoPrincipal.id,
      habilitaCamposGestacionais: !!procedimentoPrincipal.habilitaCamposGestacionais,
      lateralidade: {
        display: lateralidade === 'NaoAplica' ? 'Não Aplica' : lateralidade,
        key: lateralidade,
      },
      procedimentoPrincipal: true,
      quantidade: procedimentoPrincipal.quantidade,
    } as any as Procedimento

    await this.verificarCoberturaVigente(procedimentoNew)

    procedimentoNew = { ...this.getBackofficeGlobalStore.solicitacaoAlterada.procedimento, ...procedimentoNew }

    this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'procedimento', value: procedimentoNew })
    this.getBackofficeGlobalStore.hideProcedimentoApi(procedimentoNew)
    this.getBackofficeGlobalStore.showProcedimentoApi(procedimentoPrincipal)
    this.showModalEditarProcedimentoPrincipal = false
    this.$forceUpdate()
    this.loadingSaveProcedimentoPrincipal = false
    this.showModalQuantidade = false
  }
}
